<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item item-row">
                <span>样式</span>
                <div class="select-box">
                    <el-select v-model="dataList.icon" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in iconOptions" :key="item.value" :label="item.label" :value="item.value">
                            <div style="margin-top: 5px">
                                <score-number v-if="item.value === 'Number'" :iconType="item.value" />
                                <score-icon v-else :iconType="item.value" />
                            </div>
                        </el-option>
                    </el-select>
                    <div class="chose-icon">
                        <score-number v-if="dataList.icon === 'Number'" :iconType="dataList.icon" />
                        <score-icon v-else :iconType="dataList.icon" />
                    </div>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <el-checkbox v-model="dataList.isInputComments" label="输入评价" size="large" />
            </div>
            <div class="setting-content-item item-row">
                <el-checkbox v-model="dataList.isLeastOne" label="至少选择一个标签" size="large" />
            </div>
        </div>
    </div>
</template>
<script setup name="kr-evaluation-setting">
import ScoreIcon from "@/components/scoreIcon/Icon.vue";
import ScoreNumber from "@/components/scoreIcon/Number.vue";
import ScoreRuler from "@/components/scoreIcon/Ruler.vue";
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

const iconOptions = [
    { label: "Star", value: "Star", icon: "" },
    { label: "Thumbs", value: "Thumbs", icon: "" },
    { label: "Smile", value: "Smile", icon: "" },
    { label: "Love", value: "Love", icon: "" },
    { label: "Number", value: "Number", icon: "" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        flex-shrink: 0;
    }
}
.select-box {
    position: relative;
    width: 100%;
    margin-left: 6px;
    .chose-icon {
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        height: 30px;
        background-color: #fff;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
}

:deep(.el-select--large) {
    width: 100%;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
:deep(.el-checkbox) {
    height: 21px;
}
</style>
